<template>
  <div>
    <b-row>
      <b-col>
        <b-form inline class="mb-2">
          <label class="mr-2">{{ trans('to') }}:</label>
          <b-form-radio v-model="to" value="list" class="mr-2" @input="onUpdate" :disabled="disabled">
            {{ trans('list') }}
          </b-form-radio>
          <b-form-radio v-if="showClassParticipantsList && !hideAllButSelfAndPreselectedList" v-model="to" value="class_participants" class="mr-2" :disabled="disabled">
            {{ trans('classes') }}
          </b-form-radio>
          <b-form-radio v-if="false" v-model="to" value="person" class="mr-2" @input="onUpdate" :disabled="disabled">
            {{ trans('person') }}
          </b-form-radio>
          <b-form-radio v-if="!hideAllButSelfAndPreselectedList && !onlyAllowListsMyselfAndClasses" v-model="to" value="people" class="mr-2" @input="onUpdate" :disabled="disabled">
            {{ trans('people') }}
          </b-form-radio>
          <b-form-radio v-if="!noSelf" v-model="to" value="self" class="mr-2" @input="onUpdate" :disabled="disabled">
            {{ trans('myself') }}
          </b-form-radio>
          <b-form-radio v-if="organization.amilia_organization_id && !hideAllButSelfAndPreselectedList" v-model="to" value="amilia" class="mr-2" @input="onUpdate" :disabled="disabled">
            Amilia
          </b-form-radio>
          <b-form-radio v-if="!onlyAllowListsMyselfAndClasses" v-model="to" value="users" class="mr-2" :disabled="disabled">
            {{ trans('users') }}
          </b-form-radio>
          <b-form-radio v-if="showCombineList && !hideAllButSelfAndPreselectedList && !onlyAllowListsMyselfAndClasses" v-model="to" value="combine" class="mr-2" :disabled="disabled">
            {{ trans('combine') }}
          </b-form-radio>
        </b-form>
      </b-col>
      <b-col v-if="!noShowCc" class="col-auto">
        <b-button variant="link" :class="`p-0 ${cc_user_ids && cc_user_ids.length ? 'text-muted' : ''}`" @click="$emit('show-cc')">
          BCC
          <span v-if="cc_user_ids && cc_user_ids.length > 0">
            ({{ cc_user_ids.length}})
          </span>
          <i v-if="!cc_user_ids || cc_user_ids.length == 0" :class="`fa fa-fw fa-${show_cc ? 'minus' : 'plus'}`"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-form-group v-if="to == 'list'">
      <list-dropdown
        :organization="organization"
        v-model="list_id"
        :no-master="noMaster"
        :no-class-participants="noClassParticipants"
        @input="onUpdate"
        @list="list = $event; onUpdate()"
        :disabled="disabled || hideAllButSelfAndPreselectedList"
      />
      <b-form-text v-if="!!list && !list.is_oto" class="text-right">
        <b-link :href="`/organization/${organization.id}/list/${list.id}`" target="_blank">
          {{ trans('list') }}
          <i class="fa fa-fw fa-external-link-alt"></i>
        </b-link>
      </b-form-text>
      <b-form-text v-if="resend_not_opened_count" class="text-danger">
        {{ trans('resend_count_note').replace(':count', numeral(resend_not_opened_count).format('0,000')) }}
      </b-form-text>
    </b-form-group>
    <b-form-group v-if="to == 'list' && list && list.type == 'upload'">
      <b-form-select :options="csvActivityOptions" v-model="csv_activity" @input="onUpdate" />
    </b-form-group>
    <b-form-group v-if="formCustomValueLabel" :label="formCustomValueLabel">
      <b-form-select :options="formCustomValueOptions" v-model="form_custom_value" @input="onUpdate" />
    </b-form-group>
    <b-form-group v-if="to == 'person'">
      <b-row>
        <b-col cols="5" v-if="type.indexOf('sms') >= 0 || type == 'both'">
          <b-form-input v-model="to_mobile" placeholder="mobile 514-123-1234" @input="onUpdate" />
        </b-col>
        <b-col cols="7" v-if="type.indexOf('email') >= 0 || type == 'both'">
          <b-form-input v-model="to_email" placeholder="email john@example.com" @input="onUpdate" />
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group v-if="to == 'people'">
      <recipients-select
        :organization="organization"
        :type="type"
        :comtype="comtype"
        :value="people"
        show-add
        @input="onPeople"
      ></recipients-select>
    </b-form-group>
    <b-form-group v-if="to == 'self'">
      <b-row>
        <b-col cols="5" v-if="type.indexOf('sms') >= 0 || type == 'both'">
          <b-form-input :value="user.mobile" readonly :state="!!user.mobile ? null : false"  :title="!user.mobile ? trans('your_mobile_not_set') : null" v-b-tooltip.hover.bottom />
        </b-col>
        <b-col cols="7" v-if="type.indexOf('email') >= 0 || type == 'both'">
          <b-form-input :value="user.email" readonly />
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group v-if="organization.amilia_organization_id" v-show="to == 'amilia'">
      <b-input-group>
        <b-form-input
          readonly
          :state="!!amilia_list && !!amilia_list.valid_count"
          :value="amilia_list && amilia_list.valid_count ? (amilia_list.valid_count + ' ' + trans('participant' + (amilia_list.valid_count > 1 ? 's' : ''))) : trans('zero_participants')"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="primary" @click="onClickAmiliaList">
            {{ trans('choose_participants') }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <oto-amilia-list-modal
        :id="amiliaModalId"
        :organization="organization"
        v-model="amilia_list"
        @input="onUpdate"
      ></oto-amilia-list-modal>
    </b-form-group>
    <b-form-group v-if="to == 'users'">
      <users-select
        :organization="organization"
        :confirmed="null"
        :placeholders="trans('users')"
        show-permission
        show-select-all
        v-model="user_ids"
        :disabled="disabled"
      ></users-select>
    </b-form-group>

    <b-form-group v-if="showCombineList" v-show="to == 'combine'">
      <b-input-group>
        <b-form-input
          readonly
          :state="!!combine_list && !!combine_list.valid_count"
          :value="combine_list ? (combineListRecipientCount + ' ' + trans('recipient' + (combineListRecipientCount > 1 || combineListRecipientCount == 0 && lang == 'en' ? 's' : '')).toLowerCase()) : trans('none')"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="primary" @click="onClickCombineList">
            {{ trans('choose_lists') }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-modal
      v-if="showCombineList"
      :id="combineModalId"
      :title="trans('combine')"
      size="xl"
      ok-only
      :ok-title="trans('close')"
      ok-variant="secondary"
    >
      <combine-list
        v-if="!!combine_list"
        :organization="organization"
        :recipient_list="combine_list"
        @list="combine_list = $event"
      ></combine-list>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
    </b-modal>

    <b-form-group v-if="showClassParticipantsList" v-show="to == 'class_participants'">
      <b-input-group>
        <b-form-input
          readonly
          :state="!!class_participants_list && !!class_participants_list.valid_count"
          :value="class_participants_list ? (classParticipantsListRecipientCount + ' ' + trans('recipient' + (classParticipantsListRecipientCount > 1 || classParticipantsListRecipientCount == 0 && lang == 'en' ? 's' : '')).toLowerCase()) : trans('none')"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="primary" @click="onClickClassParticipantsList">
            {{ trans('choose_classes') }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-modal
      v-if="showClassParticipantsList"
      :id="classModalId"
      :title="trans('classes')"
      size="xl"
      ok-only
      :ok-title="trans('cancel')"
      ok-variant="secondary"
    >
      <class-participants-list
        v-if="!!class_participants_list"
        :organization="organization"
        :recipient_list="class_participants_list"
        @list="class_participants_list = $event"
      ></class-participants-list>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
    </b-modal>
  </div>
</template>

<script>
  import OtoAmiliaListModal from './SendOutOtoAmiliaListComponent'
  import ListDropdown from './../list/ListDropdown'
  import RecipientsSelect from './../recipient/RecipientsSelect'
  import UsersSelect from './../orguser/UsersSelect'
  import CombineList from './../list/CombineList'
  import ClassParticipantsList from './../list/ClassParticipantsList'

  export default {
    props: {
      organization: Object,
      user: Object,
      type: {
        type: String,
        default: 'both', // both, email or sms
      },
      comtype: {
        type: String,
        default: 'reminders',
      },
      value: Object,
      resend_not_opened_count: Number,
      show_cc: {
        type: Boolean,
        default: false,
      },
      cc_user_ids: Array,
      noShowCc: {
        type: Boolean,
        default: false,
      },
      noSelf: {
        type: Boolean,
        default: false,
      },
      noMaster: {
        type: Boolean,
        default: false,
      },
      noClassParticipants: {
        type: Boolean,
        default: false,
      },
      showCombineList: {
        type: Boolean,
        default: false,
      },
      showClassParticipantsList: {
        type: Boolean,
        default: false,
      },
      modalPostfix: {
        type: String,
        default: 'new',
      },
    },
    components: {
      OtoAmiliaListModal,
      ListDropdown,
      RecipientsSelect,
      UsersSelect,
      CombineList,
      ClassParticipantsList,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        numeral: numeral,
        showAdminTools: window.SHOW_ADMIN_TOOLS,
        busy: false,
        error: null,
        to: this.value.to,
        list_id: this.value.list_id,
        list: null,
        csv_activity: this.value.csv_activity,
        csv_activities: null,
        amilia_list: null,
        to_mobile: this.value.to_mobile,
        to_email: this.value.to_email,
        people: this.value.people,
        user_ids: this.value.user_ids,
        form_custom_value: this.value.form_custom_value,
        form_custom_values: null,
        disabled: !!this.resend_not_opened_count,
        cache: {},
        combine_list: null,
        class_participants_list: null,
      }
    },
    computed: {
      csvActivityOptions() {
        if (!this.csv_activities) return []
        let options = [{
          value: null,
          text: trans('any_activity'),
        }]
        let activity = this.csv_activity ? this.csv_activity.toLowerCase().trim() : null
        if (activity && !this.csv_activities[activity]) {
          options.push({
            value: activity,
            text: this.csv_activity,
          })
        }
        _.forEach(this.csv_activities, (o, a) => {
          options.push({
            value: a,
            text: `${o.name} (${o.count})`,
          })
        })
        return options
      },
      formCustomValueLabel() {
        if (this.to != 'list' || !this.list || !this.list.has_form || !this.list.form.custom) return null
        let label = trans('custom_field')
        if (this.list.form.custom_label) label += ` (${this.list.form.custom_label})`
        return label
      },
      formCustomValueOptions() {
        if (!this.formCustomValueLabel) return []
        if (!this.form_custom_values) return []
        let options = [{
          value: null,
          text: trans('any_value'),
        }]
        _.forEach(this.form_custom_values, (o, a) => {
          options.push({
            value: a,
            text: `${o.name} (${o.count})`,
          })
        })
        return options
      },
      combineListRecipientCount() {
        if (!this.combine_list || !this.combine_list.valid_count) return 0
        return this.combine_list.valid_count
      },
      classParticipantsListRecipientCount() {
        if (!this.class_participants_list || !this.class_participants_list.valid_count) return 0
        return this.class_participants_list.valid_count
      },
      amiliaModalId() {
        return `send-oto-amilia-${this.amilia_list ? this.amilia_list.id : this.modalPostfix}`
      },
      combineModalId() {
        return `combine-list-modal-${this.combine_list ? this.combine_list.id : this.modalPostfix}`
      },
      classModalId() {
        return `class-list-modal-${this.class_participants_list ? this.class_participants_list.id : this.modalPostfix}`
      },
      hideAllButSelfAndPreselectedList() {
        return ['owner', 'admin', 'attendant'].indexOf(this.organization.auth_user.permission) == -1 &&
          !this.organization.auth_user.can_access_client_ci
      },
      onlyAllowListsMyselfAndClasses() {
        return this.organization.auth_user.permission == 'staff'
      },
    },
    watch: {
      list() {
        this.loadCsvActivities()
        this.loadFormCustomValues()
      },
      value() {
        this.to = this.value.to
        this.list_id = this.value.list_id
      },
      user_ids() {
        this.onUpdate()
      },
      combine_list() {
        this.onUpdate()
      },
      class_participants_list() {
        this.onUpdate()
        this.$bvModal.hide(this.classModalId)
      },
    },
    methods: {
      onClickAmiliaList() {
        this.$bvModal.show(this.amiliaModalId)
      },
      onClickCombineList() {
        this.$bvModal.show(this.combineModalId)
        if (!!this.combine_list) return

        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list`
        axios.post(url, {
          type: 'master',
          name: trans('master_list'),
          description: null,
        })
        .then(response => {
          this.busy = false
          this.combine_list = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClickClassParticipantsList() {
        this.$bvModal.show(this.classModalId)
        if (!!this.class_participants_list) return

        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list`
        axios.post(url, {
          type: 'class_participants',
          name: trans('list_type_class_participants'),
          description: null,
        })
        .then(response => {
          this.busy = false
          this.class_participants_list = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      serialize() {
        return {
          to: this.to,
          list_id: this.list_id,
          list: this.list,
          csv_activity: this.to == 'list' && this.list && this.list.type == 'upload' ? this.csv_activity : null,
          amilia_list: this.amilia_list,
          to_mobile: this.to_mobile,
          to_email: this.to_email,
          people: this.people,
          form_custom_value: this.form_custom_value,
          user_ids: this.user_ids,
          combine_list: this.combine_list,
          class_participants_list: this.class_participants_list,
        }
      },
      onPeople(recipients) {
        this.people = recipients
        this.onUpdate()
      },
      onUpdate() {
        this.$emit('input', this.serialize())
      },
      loadCsvActivities() {
        if (this.to != 'list' || !this.list || this.list.type != 'upload') {
          this.csv_activities = null
          return
        }

        if (this.cache[this.list.id]) {
          this.csv_activities = this.cache[this.list.id]
          return
        }

        let url = `/organization/${this.organization.id}/list/${this.list.id}/csv_activities`
        axios.get(url)
        .then(response => {
          this.csv_activities = this.cache[this.list_id] = response.data
        })
        .catch(error => {
          _.toastError(this, _.errorFromAjax(error))
        })
      },
      loadFormCustomValues() {
        if (this.to != 'list' || !this.list || !this.list.has_form || !this.list.form.custom) {
          this.form_custom_values = null
          return
        }

        if (this.cache[this.list.id]) {
          this.form_custom_values = this.cache[this.list.id]
          return
        }

        let url = `/organization/${this.organization.id}/list/${this.list.id}/form_custom_values`
        axios.get(url)
        .then(response => {
          this.form_custom_values = this.cache[this.list_id] = response.data
        })
        .catch(error => {
          _.toastError(this, _.errorFromAjax(error))
        })
      },
    },
    mounted() {
      window.sendOutTo = this
    },
  }
</script>
